import { TimelineItemModelType } from '@models/TimelineItem';
import { GetNextAndPreviousTimelineItemsArgs } from '@modules/timetable';

export const getNextAndPreviousTimelineItems = ({
  timelineItems,
  currentTimelineItemId,
}: GetNextAndPreviousTimelineItemsArgs): {
  previousItem?: TimelineItemModelType;
  nextItem?: TimelineItemModelType;
} => {
  const itemIndex = timelineItems.findIndex((timelineItem) => timelineItem.id === currentTimelineItemId);
  const previousItem = timelineItems[itemIndex - 1];
  const nextItem = timelineItems[itemIndex + 1];

  return {
    previousItem,
    nextItem,
  };
};
